import { t } from '../services/i18n.js';

export function renderNavbar(container) {
  const current = window.location.hash || '#/';

  const nav = document.createElement('nav');
  nav.className = 'navbar-bottom';

  const items = [
    { 
      path: '#/home', 
      icon: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>`, 
      label: t('navFeed') 
    },
    { 
      path: '#/upload', 
      icon: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>`, 
      label: t('navAnalyze') 
    },
    { 
      path: '#/competitions', 
      icon: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path><path d="M2 12h20"></path></svg>`, 
      label: t('navCompetitions') 
    },
    {
      path: '#/teams',
      icon: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2"></rect><path d="M9 8h6"></path><path d="M9 16h6"></path><circle cx="12" cy="12" r="2"></circle></svg>`,
      label: t('navTeams')
    },
    { 
      path: '#/quiz', 
      icon: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>`, 
      label: t('navQuiz') 
    },
    { 
      path: '#/leaderboards', 
      icon: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>`, 
      label: t('navScores') 
    },
    { 
      path: '#/profile', 
      icon: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`, 
      label: t('navProfile') 
    }
  ];

  items.forEach(item => {
    const a = document.createElement('a');
    a.className = 'nav-item' + (current.startsWith(item.path) ? ' active' : '');
    a.href = item.path;
    a.innerHTML = `<span aria-hidden="true" style="display:flex; align-items:center; justify-content:center; margin-bottom: 2px;">${item.icon}</span><span>${item.label}</span>`;
    a.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.hash = item.path;
    });
    nav.appendChild(a);
  });

  container.appendChild(nav);
  return nav;
}
